import { render, staticRenderFns } from "./RemoveApparatus.vue?vue&type=template&id=3719b1c2"
import script from "./RemoveApparatus.vue?vue&type=script&lang=js"
export * from "./RemoveApparatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3719b1c2')) {
      api.createRecord('3719b1c2', component.options)
    } else {
      api.reload('3719b1c2', component.options)
    }
    module.hot.accept("./RemoveApparatus.vue?vue&type=template&id=3719b1c2", function () {
      api.rerender('3719b1c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApparatusDetails/RemoveApparatus.vue"
export default component.exports